import styled from "@emotion/styled";

export const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin-top: 24px;
  margin-bottom: 16px;
  align-items: center;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  //TODO: Pagination 컴포넌트 수정하면, 없애기
  .interaction {
    background-color: transparent;
  }
`;

export const FilterContainer = styled.div`
  width: 530px;
  display: flex;
  gap: 12px;
`;
